import resourceActionsJson from './resource-actions.json' with { type: 'json' };
export const resourceActions = resourceActionsJson;
const actionResourceMap = Object.entries(resourceActions).reduce((map, [namespace, { resource, actions = [] }]) => {
    for (const action of actions) {
        if (typeof action === 'string') {
            map.set(`${namespace}:${action}`, resource);
        }
        else {
            const { verb, statuses } = action;
            map.set(`${namespace}:${verb}`, resource);
            for (const status of statuses) {
                map.set(`${namespace}:${verb}/${status}`, resource);
            }
        }
    }
    return map;
}, new Map());
export function interpolateValues(string, variables) {
    return string.replace(/{(.+?)}/g, (_match, variableKey) => String(variables[variableKey] ?? '*'));
}
export function getActionResourceString(action, data) {
    const resourceFormat = actionResourceMap.get(action);
    if (!resourceFormat) {
        throw new Error(`Invalid action: "${action}"`);
    }
    return interpolateValues(resourceFormat, data);
}
export function getResourceString(type, data) {
    const namespace = resourceActions[type];
    if (!namespace) {
        throw new Error(`Invalid resource namespace: "${type}"`);
    }
    return interpolateValues(namespace.resource, data);
}
export function validateAction(action) {
    return actionResourceMap.has(action);
}
export function ensureAction(action) {
    if (validateAction(action)) {
        return action;
    }
    throw new Error(`Invalid action: "${action}"`);
}
